import { PayloadAction } from '@reduxjs/toolkit'
import { call, fork, put, select } from 'redux-saga/effects'

import { handleToggleActiveDrawable2D } from './handleToggleActiveDrawable'
import { OpeningGroup } from '../../../models/activeDrawable'
import { DRAWABLE_TYPES, NEW_IMUP_JOIST_TYPES_GROUP } from '../../../shared/constants/drawable-types'
import { JOIST_DIRECTION } from '../../../shared/constants/joist'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Select, Workspace } from '../../lib/toolBoxes/2D'
import { getSelectedMaterial, setLatestAnalyticsAction } from '../../slices/2D'
import { setJoistDirection } from '../../slices/common'
import { selectIsMaterialGroupActivationBlocked } from '../../slices/masterSetPlan'
import { AnalyticsActionEdgeType, AnalyticsActionType } from '../../types'

export function* handleSetActiveDrawableGroup2D({
    payload,
}: PayloadAction<{
    activeDrawableGroup: OpeningGroup
    activeDrawableId: number | number[] | undefined
}>) {
    try {
        const manager: PaperManager = yield call(managers.get2DManager)

        if (!manager) return

        const { id: activeDrawableGroupId } = payload.activeDrawableGroup

        const workspaceTool: Workspace = yield call(manager.getTool, Workspace.NAME)
        const selectTool: Select = yield call(manager.getTool, Select.NAME)

        // Show only this drawable group when we activate it
        // If there is no active drawable group, we reset all shapes back to normal
        if (!activeDrawableGroupId) {
            yield call(selectTool.removeHandles)

            yield call(workspaceTool.deactivateAllDrawables)

            yield call(workspaceTool.lockItems, false)
        } else {
            const isGroupActivationBlocked: boolean = yield select(selectIsMaterialGroupActivationBlocked)

            if (isGroupActivationBlocked) return

            yield call(selectTool.clearAllMultiSelections, true)
            const openingIds = payload.activeDrawableGroup.openings.map((opening) => opening.id)
            const selectedMaterialType: DRAWABLE_TYPES | null = yield select(getSelectedMaterial)
            const isRimboard = selectedMaterialType === DRAWABLE_TYPES.RIMBOARD

            if (!isRimboard) {
                yield call(workspaceTool.lockItems, true, openingIds)
            }

            // activeDrawableId is used when we click on canvas item or on left hand panel item
            // null is used when we click on the whole group
            yield fork(handleToggleActiveDrawable2D, payload.activeDrawableId || null)

            if (NEW_IMUP_JOIST_TYPES_GROUP.includes(payload.activeDrawableGroup.type)) {
                yield put(
                    setJoistDirection(
                        payload.activeDrawableGroup.settings.direction
                            ? (payload.activeDrawableGroup.settings.direction.toLowerCase() as JOIST_DIRECTION)
                            : null
                    )
                )
            }

            if (payload.activeDrawableGroup.openings.length > 0) {
                yield put(
                    setLatestAnalyticsAction({
                        startOrStop: AnalyticsActionEdgeType.START,
                        actionType: AnalyticsActionType.SELECTION_MODIFICATION,
                        settings: payload.activeDrawableGroup.settings,
                    })
                )
            }
        }
    } catch (error) {
        yield call(console.error, error)
    }
}
